/* global modForm Modalytics */
import { getCurrentStep, markFieldAsInvalid, unmarkFieldAsInvalid, trackInvalidFieldsInHeap } from '../helpers';
import { isFieldValid, isValidName } from '../validators';
/**
 * Validate Form Fields
 * @param {HTMLElement} $form - form element containing inputs to validate
 * @returns {boolean} valid
 */
export function isFormValid($form) {
	let isValid = true;

	if ($form) {
		const invalidFields = [];
		let $firstName = null, $lastName = null;

		$form.querySelectorAll('[data-required]').forEach(function(element) {
			const $field = element;
			const validationType = $field.getAttribute('data-required');

			if ('radio' === $field.getAttribute('type')) {
				isValid = $form.querySelectorAll('input[name="' + $field.getAttribute('name') + '"]:checked').length;
			} else if ('checkbox' === $field.getAttribute('type')) {
				isValid = $form.querySelectorAll('input[name="' + $field.getAttribute('name') + '"]:checked').length;
			} else {
				isValid = isFieldValid($field, validationType);
			}

			// Validate first and last name can not be the same
			if (validationType === 'name' && isValid) {
				// Remove existing errors
				unmarkFieldAsInvalid($field);

				$firstName = $field?.name === 'firstName' ? $field : $firstName;
				$lastName = $field?.name === 'lastName' ? $field : $lastName;

				if ($firstName && $lastName) {
					const firstName = $firstName.value;
					const lastName = $lastName.value;
					isValid = isValid && isValidName(firstName, lastName);

					if (!isValid) {
						markFieldAsInvalid($firstName);
						markFieldAsInvalid($lastName);
						Modalytics.heap('track', ['Validation Error | Identical First and Last Name', {}]);
					}
				}
			}

			if (!isValid) {
				const invalidFieldName = $field.name.charAt(0).toUpperCase() + $field.name.slice(1);

				if (invalidFields.indexOf(invalidFieldName) === -1) {
					invalidFields.push(invalidFieldName);
				}
				if ($field.name === 'zip' && modForm.opts.zipFormSelectorsToSync.length) {
					const zipInputs = [];
					const mainFormZip = modForm.opts.form.querySelector('input[name="zip"]');
					if (mainFormZip) {
						zipInputs.push(mainFormZip);
					}
					modForm.opts.zipFormSelectorsToSync.forEach(function(zipFormId) {
						zipInputs.push(document.querySelector(`${zipFormId} input[name="zip"]`));
					});
					zipInputs.forEach(function(zipElement) {
						zipElement.value = $field.value;
						markFieldAsInvalid(zipElement);
					});
				} else {
					markFieldAsInvalid($field);
				}

				isValid = false;
			}
		});

		// Check if there's already an invalid field on current step
		if (modForm.opts.steps) {
			const currentStep = getCurrentStep();
			if (currentStep.querySelectorAll('.' + modForm.opts.fieldErrorCls).length > 0) {
				isValid = false;
			}
		}

		// Check for invalid inputs
		if (invalidFields.length) {
			isValid = false;
			invalidFields.forEach(function(fieldName) {
				trackInvalidFieldsInHeap(fieldName);
			});
		}
	}

	return isValid;
}
